<page-heading title="Comunicação com usuário" description="Registre informações de forma comunicativa sobre a plataforma Trendmulti"
  [hasBreadcrumb]="true" />

<ul class="nav nav-tabs nav-bordered mb-3">
  <li class="nav-item">
    <a 
      class="nav-link active"
      id="communication-tab"
      data-bs-toggle="tab"
      data-bs-target="#communication"
      type="button"
      role="tab"
      aria-controls="communication"
      aria-selected="true"
    >
      <i class="mdi mdi-home-variant d-md-none d-block"></i>
      <span class="d-none d-md-block">Comunicação</span>
    </a>
  </li>
  <li class="nav-item">
    <a 
      class="nav-link"
      id="login-tab"
      data-bs-toggle="tab"
      data-bs-target="#login"
      type="button"
      role="tab"
      aria-controls="login"
      aria-selected="false"
    >
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">Login</span>
    </a>
  </li>
</ul>

<div class="tab-content" id="tabComponentsContent">

  <div class="tab-pane fade show active" id="communication" role="tabpanel" aria-labelledby="communication-tab">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-xs-12 col-sm-8 col-md-10 col-lg-10 input-trend-search">
                <input type="search" #searchBox (keyup)="search(searchBox.value)" class="form-control"
                  placeholder="Pesquisar..." />
                <span class="mdi mdi-magnify search-icon"></span>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 trend-button">
                <button type="button" class="btn btn-info fw-bold" [routerLink]="['/info/add']">
                  + Adicionar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          @if (pager.total === 0) {
          <div class="card-body">
            <empty-records-component [message]="'Nenhuma informação encontrada para a plataforma'"
              [labelButton]="pager.total === 0 ? 'Adicionar' : ''" (emitEvent)="addNew()" />
          </div>
          } @else {
          <div class="card-body table-responsive">
            <table class="table table-hover table-centered mb-0">
              <thead>
                <tr>
                  <th class="text-primary-emphasis">Nome</th>
                  <th class="text-primary-emphasis">Tipo</th>
                  <th class="text-primary-emphasis">Status</th>
                  <th class="text-primary-emphasis">Data de Início</th>
                  <th class="text-primary-emphasis">Data de Fim</th>
                  <th class="text-primary-emphasis">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                @for (item of pager.list; track item) {
                <tr>
                  <td>
                    <img [src]="item.content" class="rounded" [alt]="item.name" height="52" /> {{ item.name }}
                  </td>
                  <td>
                    {{ item.type === 'IMAGE' ? 'Imagem' : '' }}
                  </td>
                  <td>
                    @if (item.actived) {
                    <span class="mx-1" class="badge text-bg-primary rounded-pill">
                      Ativo
                    </span>
                    } @else {
                    <span class="mx-1" class="badge text-bg-info rounded-pill">
                      Inativo
                    </span>
                    }
                  </td>
                  <td>
                    {{ item.startedAt | date: 'dd/MM/yyyy' }}
                  </td>
                  <td>
                    {{ item.finishedAt | date: 'dd/MM/yyyy' }}
                  </td>
                  <td class="text-end">
                    <button class="btn btn-dropdown-list" [matMenuTriggerFor]="menu" type="button">
                      <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item [routerLink]="['/info/edit', item._id]">
                        Editar
                      </button>
                      <button mat-menu-item (click)="delete(item)">
                        Remover
                      </button>
                    </mat-menu>
                  </td>
                </tr>
                }
              </tbody>
            </table>
    
            @if (pager.total > pager.perPage) {
            <paginator [pager]="pager" (onPager)="loadPage($event)" />
            }
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="tab-pane fade" id="login" role="tabpanel" aria-labelledby="login-tab">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <h6 class="card-header">Imagem do Painel de Login</h6>
          <div class="card-body">
            <div class="row position-relative">
              <div class="col-lg-12">
                <div class="upload-area">
                  @if (loadingSpinner$ | async) {
                  <loading-component class="loading" />
                  } @else {
                  @if (!loginImage) {
                  <div class="placeholder-content" (click)="addLoginImage()">
                    <i class="mdi mdi-cloud-upload-outline upload-icon text-primary"></i>
                    <p class="text-primary">Clique aqui para carregar</p>
                    <p class="text-muted">
                      Sugestão: PNG, JPG ou JPEG (Máx. 1280x853px)
                    </p>
                  </div>
                  }
                  }

                  <div class="upload-area__image" [ngStyle]="
                      (loadingSpinner$ | async) ? { filter: 'blur(5px)' } : {}
                    ">
                    @if (loginImage) {
                    <img [src]="loginImage" alt="Imagem do login" class="preview-img"
                      (click)="$event.stopPropagation()" (error)="onImageLoadError()" />
                    <button class="btn btn-outline-danger" type="button"
                      (click)="removeLoginMedia(); $event.stopPropagation()">
                      <i class="mdi mdi-trash-can-outline"></i>
                    </button>
                    }
                  </div>

                  <input #fileInputLogin type="file" accept="image/jpeg, image/png" (change)="onSelectLoginImage($event)" />
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>